import request from '@/libs/request'

//后台菜单 列表
export function systemMenuListApi (data) {
  return request({
    url: `system/menu`,
    method: 'get',
    params: data
  })
}

//后台菜单 树形数据
export function systemMenuTreeApi (data) {
  return request({
    url: `system/menuTree`,
    method: 'get',
    params: data
  })
}

//后台菜单 详情
export function systemMenuDetailApi (id) {
  return request({
    url: `system/menu/` + id,
    method: 'get'
  })
}


//后台菜单 编辑/添加
export function systemMenuSaveApi (data) {
  return request({
    url: `system/menu`,
    method: 'post',
    data: data
  })
}

//后台菜单 删除
export function systemMenuDelApi (id) {
  return request({
    url: `system/menu/` + id,
    method: 'delete'
  })
}

